export default __webpack_public_path__ + "static/media/hardMenuIcon.76b6e3b2.svg";